<div class="container">
    <label class="title">{{'customDateSelection' | translate}}</label>

    <div class="date-container">
        <label class="label" for="">{{'fromDate' | translate}}</label>
        <mat-form-field color="accent">
            <input  placeholder="DD-MM-YYYY" [formControl]="startDateCtrl" matInput [matDatepicker]="startDate" [max]="maxDate">
            <mat-datepicker-toggle matIconSuffix [for]="startDate" ></mat-datepicker-toggle>
            <mat-datepicker #startDate></mat-datepicker>
        </mat-form-field>
    
        <label class="label" for="">{{'toDate' | translate}}</label>
        <mat-form-field color="accent">
            <input  placeholder="DD-MM-YYYY" [formControl]="endDateCtrl" matInput [matDatepicker]="endDate" [max]="maxDate">
            <mat-datepicker-toggle matIconSuffix [for]="endDate"></mat-datepicker-toggle>
            <mat-datepicker #endDate></mat-datepicker>
        </mat-form-field>
    </div>

    <div class="button-container">
            <button class="ok-button" (click)="close('ok')">{{'ok' | translate}}</button>
            <button class="cancel-button" (click)="close('close')">{{'cancel' | translate}}</button>
    </div>
</div>